import { CssRender as e } from "../../../../../css-render@0.15.14/node_modules/css-render/esm/CssRender.js";
const { c } = e(), o = "vueuc-style";
export {
  c,
  o as cssrAnchorMetaName
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/shared/cssr.js
// module id = 326
// module chunks = 41